module.exports = __webpack_public_path__ + "97102b6cbf9d5f671452907c67065a41.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/fj.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/fj.svg
// module chunks = 0